<template>
	<div>
		<div style="color: #3e3e3e;
	  		font-size: 18px;margin-bottom: 15px;"></div>
		<el-tabs type="border-card" v-model="activeName">
			<el-tab-pane name="one" label="弹出广告">
				<list1></list1>
			</el-tab-pane>
			<!-- 	    <el-tab-pane name="two" label="加盟管理">
			<list2 ></list2>
		</el-tab-pane> -->
			<el-tab-pane name="three" label="弹出活动(领券)">
				<list3></list3>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
	import list1 from "./ad.vue"
	// import list2 from "./storelist/storelist2.vue"
	import list3 from "./at.vue"
	export default {
		components: {
			list1,
			// list2,
			list3,
		},
		data() {
			return {
				activeName: "one"
			};
		},
		mounted() {
			if (this.$route.query.id == 1) {
				this.activeName = "one"
			}
			if (this.$route.query.id == 2) {
				this.activeName = "two"
			}
			if (this.$route.query.id == 3) {
				this.activeName = "three"
			}
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>
</style>